import api from "@/plugins/api";
import { CONTACT_SUBJECT_TYPE } from "../../domain/subjectTypes";
export async function getConformityState(contactId) {
    const response = await api.get(`/opconf-conformity-states/${CONTACT_SUBJECT_TYPE}/${contactId}`, { unwrapEnvelope: true });
    return response.data;
}
